export const MAX_RECENTLY_VIEWED = 4
export const RECENTLY_VIEWED_PERFORMERS_KEY = 'recentlyViewedPerformers'
export const RECENTLY_VIEWED_PRODUCTIONS_KEY = 'recentlyViewedProductions'
